module.exports = __webpack_public_path__ + "img/draw.1a5661b7.png";